import { createSelector } from "reselect";
import { createReducer } from "typesafe-actions";

import { RootState } from "@app/store/rootReducer";

import { Actions, createTrips, updateTrip } from "./actions";

interface TripModalState {
  creating?: boolean;
  updating?: boolean;
}

const initialState: TripModalState = {};

const tripModal = createReducer<TripModalState, Actions>(initialState)
  .handleAction(createTrips.request, (state) => ({
    ...state,
    creating: true,
  }))
  .handleAction([createTrips.success, createTrips.failure], (state) => ({
    ...state,
    creating: false,
  }))
  .handleAction(updateTrip.request, (state) => ({
    ...state,
    updating: true,
  }))
  .handleAction([updateTrip.success, updateTrip.failure], (state) => ({
    ...state,
    updating: false,
  }));

export type TripModalActions = Actions;

const tripModalState = (state: RootState) => state.component.tripModal;
export const isCreating = createSelector(tripModalState, ({ creating }) => creating);
export const isUpdating = createSelector(tripModalState, ({ updating }) => updating);

export default tripModal;
